import type OlMap from 'ol/Map'

import { listenToLanguageChange } from '@/intl'

import { listenToEnvironmentReady } from '../../../atoms'

import { registerFullScreenControl } from './registerFullScreenControl'
import { registerOverviewMapControl } from './registerOverviewMapControl'
import { registerScaleControl } from './registerScaleControl'
import { registerSearchControl } from './registerSearchControl'
import { refreshZoomControl, registerZoomControl } from './registerZoomControl'
import { getTexts } from './texts'

export const connectMapControlsToLanguage = (map: OlMap) => {
  return listenToLanguageChange(() => {
    const texts = getTexts()

    refreshZoomControl(map, texts)
  })
}

export const registerMapControls = (
  map: OlMap,
  tile: uui.domain.ui.map.MapTile,
  useMetricSystem: boolean = true,
) => {
  const texts = getTexts()

  const unsubscribe = listenToLanguageChange(() => {
    registerZoomControl(map, texts)
    registerScaleControl(map, useMetricSystem)
    registerSearchControl(map)
    registerFullScreenControl(map)
    //registerMapTilesControl(map, tile, texts)
    unsubscribe()
  })

  const unsubscribeEnvironmentReadyHandlers = listenToEnvironmentReady(env => {
    if (env.status !== 'ready') return
    registerOverviewMapControl(map, tile, texts)
    unsubscribeEnvironmentReadyHandlers()
  })
}

export { refreshScaleControl } from './registerScaleControl'
